import React, { useState } from "react";

const SearchBar = ({ onTermSubmit }) => {
  const [term, setTerm] = useState("");

  const onFormSubmit = (event) => {
    event.preventDefault();

    onTermSubmit(term);
  };

  return (
    <div className="search-bar ui segment">
      <form onSubmit={onFormSubmit} className="ui form">
        <div className="ui search field">
          <label style={{ fontSize: "1rem" }}>Search for a video</label>
          <div className="ui icon input">
            <input
              type="text"
              value={term}
              onChange={(event) => setTerm(event.target.value)}
              className="prompt"
              style={{ border: "1px solid black" }}
            />
            <i className="search icon"></i>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
